import React from 'react';

import { Typography } from '@mui/material';

import type { Nullable } from '@clearverify/types';

import { VerificationRequestStripePaymentStatus } from 'src/api';
import type { SxProp } from 'src/types/mui';

interface InboxItemStatusPaymentProps {
  stripePaymentStatus: Nullable<VerificationRequestStripePaymentStatus>;
}

export const InboxItemStatusPayment: React.FC<InboxItemStatusPaymentProps> = ({
  stripePaymentStatus,
}) => {
  if (stripePaymentStatus === VerificationRequestStripePaymentStatus.Processing) {
    return (
      <Typography variant="body3" sx={statusPaymentStyles[stripePaymentStatus]}>
        Payment Pending
      </Typography>
    );
  }
  if (stripePaymentStatus === VerificationRequestStripePaymentStatus.Canceled) {
    return (
      <Typography variant="body3" sx={statusPaymentStyles[stripePaymentStatus]}>
        Payment Failure
      </Typography>
    );
  }
  return null;
};

const statusPaymentStyles = {
  [VerificationRequestStripePaymentStatus.Processing]: theme => ({
    color: theme.palette.text.secondary,
  }),
  [VerificationRequestStripePaymentStatus.Canceled]: theme => ({
    color: theme.palette.error.main,
  }),
} as const satisfies {
  [key in (keyof typeof VerificationRequestStripePaymentStatus)[number]]: SxProp;
};
